import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CitaContext } from '../context/CitaContext';
import MetodoPago from '../components/cliente/MetodoPago';

const Pago = () => {
  const { 
    servicioSeleccionado, 
    fechaSeleccionada, 
    horaSeleccionada,
    metodoPago
  } = useContext(CitaContext);
  
  const navigate = useNavigate();
  
  // Redireccionar si no hay datos completos
  useEffect(() => {
    if (!servicioSeleccionado || !fechaSeleccionada || !horaSeleccionada) {
      navigate('/servicios');
    }
  }, [servicioSeleccionado, fechaSeleccionada, horaSeleccionada, navigate]);
  
  const formatoFecha = (fecha) => {
    return fecha.toLocaleDateString('es-ES', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };
  
  const handleConfirmar = () => {
    if (metodoPago) {
      navigate('/confirmacion');
    } else {
      alert('Por favor selecciona un método de pago');
    }
  };
  
  const handleAtras = () => {
    navigate('/agendar-cita');
  };
  
  if (!servicioSeleccionado || !fechaSeleccionada || !horaSeleccionada) {
    return null;
  }
  
  return (
    <div className="booking-page">
      <header className="booking-topbar">
        <div className="booking-topbar-inner">
          <div>
            <h2 className="booking-topbar-title">Sistema de Citas Medicas</h2>
            <p className="booking-topbar-subtitle">Confirmacion y pago de tu reserva</p>
          </div>
          <div className="booking-step-badge">
            <i className="fas fa-credit-card"></i>
            <span>Paso 3 de 3</span>
          </div>
        </div>
      </header>

      <main className="booking-main">
        <div className="booking-panel">
          <div className="booking-steps">
            <div className="booking-step is-complete">
              <i className="fas fa-user-edit" style={{ marginRight: '8px' }}></i>
              Informacion personal
            </div>
            <div className="booking-step is-complete">
              <i className="fas fa-calendar-day" style={{ marginRight: '8px' }}></i>
              Fecha y hora
            </div>
            <div className="booking-step is-active">
              <i className="fas fa-money-check-alt" style={{ marginRight: '8px' }}></i>
              Pago
            </div>
          </div>

          <div className="booking-content">
            <div className="booking-summary-card">
              <h3 className="booking-summary-title">
                <i className="fas fa-file-invoice-dollar" style={{ color: '#6a5acd' }}></i>
                Resumen de la cita
              </h3>

              <div className="booking-summary-grid">
                <div className="booking-summary-item">
                  <div className="booking-summary-label">Servicio</div>
                  <div className="booking-summary-value">{servicioSeleccionado.titulo}</div>
                </div>
                <div className="booking-summary-item">
                  <div className="booking-summary-label">Fecha</div>
                  <div className="booking-summary-value">{formatoFecha(fechaSeleccionada)}</div>
                </div>
                <div className="booking-summary-item">
                  <div className="booking-summary-label">Hora</div>
                  <div className="booking-summary-value">{horaSeleccionada}</div>
                </div>
                <div className="booking-summary-item">
                  <div className="booking-summary-label">Total a pagar</div>
                  <div className="booking-summary-value">${servicioSeleccionado.precio}</div>
                </div>
              </div>
            </div>

            <MetodoPago />
          </div>

          <div className="booking-actions">
            <button onClick={handleAtras} className="booking-btn booking-btn-secondary" type="button">
              <i className="fas fa-arrow-left"></i>
              Volver a Fecha y Hora
            </button>

            <button onClick={handleConfirmar} className="booking-btn booking-btn-primary" type="button">
              Confirmar cita
              <i className="fas fa-check-circle"></i>
            </button>
          </div>
        </div>

        <div className="booking-note-card">
          <h4 className="booking-note-title">
            <i className="fas fa-shield-alt"></i>
            Seguridad y politicas
          </h4>
          <ul className="booking-note-list">
            <li>Tu reserva se confirma al finalizar este paso.</li>
            <li>Si elegiste transferencia, sube el comprobante para validacion.</li>
            <li>Puedes reprogramar con al menos 24 horas de anticipacion.</li>
          </ul>
        </div>
      </main>

      <footer className="booking-footer">
        <p>Copyright 2025 - BM Creatividad</p>
      </footer>
    </div>
  );
};

export default Pago;
